import { Component, OnInit } from '@angular/core';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';
import { Postulacion } from 'src/app/project/interfaces/postulacion';
import { PostulacionesService } from 'src/app/project/services/postulaciones.service';

@Component({
  selector: 'app-postulaciones',
  templateUrl: './postulaciones.component.html',
  styleUrls: ['./postulaciones.component.css']
})
export class PostulacionesComponent implements OnInit {

  public postulaciones: Postulacion[];
  public loading: boolean = true;

  getAyudaEstadoPostulacion(estado){
    let mensaje = 'No hay información';
    switch(estado){
      case 'Aceptado':
        mensaje = 'Puedes acceder al curso si aún se encuentra disponible. Vaya a mis cursos.'
        break;
      case 'Rechazada':
        mensaje = 'Es posible que no queden cupos o el programa se haya cancelado. Para más detalles escríbanos un correo.'
        break;
      case 'En Revisión':
        mensaje = 'A la espera de que finalice la inscripción. Le avisaremos al correo cuando estemos revisando.'
        break;

      case 'Pendiente de pago':
        mensaje = 'Debe realizar el pago para acceder al curso. Presione en el botón de pago para continuar.'
        break;
    }
    return mensaje; 
  }

  constructor(
    private postulacionesService: PostulacionesService,
    private erroresHandler: ErroresHandler
  ) { 
  }

  public tipoCursos: any[] = [
    {label: 'Ver todo', value: null},
    {label: 'GRATUITO', value: 'GRATUITO'},
    {label: 'PRIVADO', value: 'PRIVADO'},
    {label: 'DE PAGO', value: 'DE PAGO'},
    {label: 'DIPLOMADO', value: 'DIPLOMADO'}
  ];

  public modalidades: any[] = [
    {label: 'Ver todo', value: null},
    {label: 'VIRTUAL', value: 'VIRTUAL'},
    {label: 'PRESENCIAL', value: 'PRESENCIAL'},
    {label: 'HIBRIDO', value: 'HIBRIDO'}
  ];

  public estados: any[] = [
    {label: 'Ver todo', value: null},
    {label: 'Aceptado', value: 'Aceptado'},
    {label: 'En Revisión', value: 'En Revisión'},
    {label: 'Rechazado', value: 'Rechazada'},
    {label: 'Pendiente de pago', value: 'Pendiente de pago'}
  ];

  public ordenar: any[] = [
    {label: 'Nombre A-Z', value: 'az'},
    {label: 'Nombre Z-A', value: 'za'},
    {label: 'Primeras postulaciones', value: 'fechaasc'},
    {label: 'Últimas postulaciones', value: 'fechadesc'}
  ];


  public postulacionesFiltradas = [];
  public filter = {
    modalidad: null, 
    tipoCurso: null,
    estado: null
  };


  filtrarPostulaciones(){

    this.loading = true;

      this.postulacionesFiltradas = this.postulaciones.filter(postulacion => 

        (this.filter.modalidad ? postulacion.curso.modalidad == this.filter.modalidad : true) 
        && 
        (this.filter.tipoCurso ? postulacion.curso.tipoCurso == this.filter.tipoCurso : true)
        && 
        (this.filter.estado ? postulacion.estado == this.filter.estado : true)
      )

      
    setTimeout(() => {
      this.loading = false
    }, 500);
  }

  ordenarPostulaciones(event){
    this.loading = true;
    switch(event){
      case 'az':
        this.postulacionesFiltradas.sort(function (a, b) {
          if (a.curso.nombre > b.curso.nombre) {
            return 1;
          }
          if (a.curso.nombre < b.curso.nombre) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        break;
      case 'za':
        this.postulacionesFiltradas.sort(function (a, b) {
          if (a.curso.nombre < b.curso.nombre) {
            return 1;
          }
          if (a.curso.nombre > b.curso.nombre) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        break;
      case 'fechaasc':
        this.postulacionesFiltradas.sort(function (a, b) {
          return new Date(a.fechaPostulacion).getTime() - new Date(b.fechaPostulacion).getTime()
        })
        break;
      case 'fechadesc':
        this.postulacionesFiltradas.sort(function (a, b) {
          return new Date(b.fechaPostulacion).getTime() - new Date(a.fechaPostulacion).getTime()
        })  
        break;
    }
    
    setTimeout(() => {
      this.loading = false
    }, 500);
    
  }

  ngOnInit(): void {
    this.postulacionesService.obtenerPostulacionesUsuario().then(postulaciones => {
      this.postulaciones = postulaciones;
      this.filtrarPostulaciones();
      this.ordenarPostulaciones('fechadesc');
      
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'Error al obtener postulaciones, intente más tarde',
          'Error'
      );
  });

  }

}
